import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import GridAutocomplete from './GridAutocomplete';
import { getLookup } from '../../services/clinicPortalServices/lookupService';

// One field for any Lookup List: type-ahead + grid browse. Saves the item value, shows its label.
// onChange(value, syntheticEvent). freeSolo allows typing a value that is not in the list.
export default function LookupField({ lookup, label, value, onChange, name, freeSolo = false, error, helperText, disabled, required }) {
    const [items, setItems] = useState([]);
    useEffect(() => {
        let alive = true;
        getLookup(lookup).then((d) => { if (alive) setItems(d || []); });
        return () => { alive = false; };
    }, [lookup]);
    const labelOf = (v) => { const it = items.find((i) => i.value === v); return it ? it.label : v || ''; };
    const emit = (v) => { const val = v == null ? '' : v; if (onChange) onChange(val, { target: { name, value: val }, persist: () => {} }); };
    return (
        <GridAutocomplete
            freeSolo={freeSolo}
            disabled={disabled}
            options={items.map((i) => i.value)}
            getOptionLabel={(v) => labelOf(v)}
            value={value || null}
            onChange={(e, v) => emit(v)}
            onInputChange={freeSolo ? (e, v, reason) => { if (reason === 'input') emit(v); } : undefined}
            renderInput={(params) => <TextField {...params} label={label} required={required} error={error} helperText={helperText} fullWidth />}
        />
    );
}
